import React from "react";
import "../styles/VideoBackground.css";  // Import the CSS file for styles

const VideoBackground = () => {
  return (
    <div className="video-background-container">
      {/* <img src="/videos/two.jpg" alt="" className="image-background"/> */}
      <video autoPlay loop muted className="video-background">
        <source src="/videos/new.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="content">
     
      </div>
    </div>
  );
};

export default VideoBackground;
